import { dotsData } from "../modules/posters/data/map_data";
import { filterMenuItems, peopleObj } from "./app-data";
import {
  init as navMenuInit,
  setTheme as setThemeNavMenuCTA,
  INavMenuItem,
  INavMenuCallback,
  NavMenuAction,
  close as navMenuClose,
} from "../modules/menu/js/nav-menu";
import {
  init as themesInit,
  IThemesCallback,
  themeAction,
} from "../modules/filters/js/themes";
import MerapiVideoPlayer, { VideoAction } from "./mainvideo";
import {
  init as initMainContent,
  filterContent,
  IMainContent,
  MainContentAction,
} from "../modules/posters/js/posters";
import {
  showThemeConnectionLines,
  clearThemeConnectionLines,
} from "../modules/posters/js/desktop_ui/lines";
/* from menu.js */
import {
  init as initIntroAnimation,
  quit as introAnimationQuit,
  IntroAnimAction,
} from "../modules/intro/js/intro";

interface IStatelessCallback {
  ACTION: VideoAction | IntroAnimAction;
  state: null;
}

enum screen {
  Entry = "entryScreen",
  IntroVideo = "introVideoScreen",
  Intro = "introScreen",
  MainContent = "main_content",
  About = "about",
  Credits = "credits",
  Resources = "resources",
  Contact = "contact",
}
const introScreens: screen[] = [screen.Entry, screen.IntroVideo, screen.Intro];

const selectableScreens: INavMenuItem[] = [
  { screenId: screen.MainContent, label: "Home" },
  { screenId: screen.About, label: "About" },
  { screenId: screen.Credits, label: "Credits" },
  { screenId: screen.Resources, label: "Resources" },
  { screenId: screen.Contact, label: "Contact" },
];

const mainState = {
  isFilterMenuOpen: false,
  isNavMenuOpen: false,
  currentScreen: screen.Entry,
  currentTheme: "all",
};

let videoPlayerInstance: unknown;

// on MainScreen
// on small screens the filter menu has a close button that appears over the navmenu hamburger icon
// this function checks if filter menu is open and adds a class to hide the navMenu hamburger icon
// but the hamburger icon becomes a close icon when nav menu is open and the close icon should be displayed
// TODO: fix the HTML so only the hamburger icon needs to be hidden not the wrapper for both close buttons
const fixMenuIconsDisplay = () => {
  const CTAButtonEl = document.getElementById("navigationMenuCTA");
  // if filterMenu is open then hide hamburger at small breakpoints
  // if navMenu is open then always display navMenu close button
  if (mainState.isNavMenuOpen) {
    CTAButtonEl!.classList.remove("hide-at-small");
  } else if (mainState.isFilterMenuOpen) {
    CTAButtonEl!.classList.add("hide-at-small");
  } else {
    CTAButtonEl!.classList.remove("hide-at-small");
  }
};

/* --------   CALLBACKS ------------------- */
// when a theme is chosen in themes/filters module the list of selected themes is returned to this main app
// and then this is passed to MainContent to filter the list of selectable videos
const appCallback = (
  props: IThemesCallback | INavMenuCallback | IStatelessCallback | IMainContent
) => {
  const { ACTION, state } = props;
  switch (ACTION) {
    case IntroAnimAction.end: {
      gotoMainContentScreen();
      break;
    }
    case themeAction.themeClicked:
      mainState.currentTheme = state.selectedFilterId;
      // send currentheme to posters desktop
      filterContent(state.selectedFilterId, peopleObj);
      break;
    case themeAction.themeRollover:
      // send rollover theme to posters desktop
      filterContent(state.selectedFilterId, peopleObj);
      // also need to display theme lines on rollover theme list item
      // currently no simple data to do this. map-data has the line ids and points, app-data for each person has connectedPeople with lideId and theme
      // need to create a list of lines and the group theme id to get colour
      showThemeConnectionLines(peopleObj, dotsData, state.selectedFilterId);
      break;
    case themeAction.themeRollout:
      // send rollover theme to posters desktop
      filterContent(mainState.currentTheme, peopleObj);
      clearThemeConnectionLines();
      break;
    case themeAction.toggleMenu: {
      mainState.isFilterMenuOpen = state.isFilterMenuOpen;
      fixMenuIconsDisplay();
      break;
    }
    case NavMenuAction.itemClicked: {
      // TODO: return an object {state.screenId}
      navMenuClose();
      naviagteToNewScreen(state);
      break;
    }
    case NavMenuAction.toggleMenu: {
      // TODO: return an object {state.isOpen}
      mainState.isNavMenuOpen = state;
      fixMenuIconsDisplay();
      break;
    }
    case VideoAction.skipIntroVideo:
      introAnimScreen();
      break;
    case VideoAction.closeVideo: {
      document.getElementById(
        "videoModal"
      )!.className = `videoholder videoholder--hide`;
      break;
    }
    case MainContentAction.loadVideo: {
      videoPlayerInstance = new MerapiVideoPlayer({
        playerName: "player",
        thisVideoId: state.videoId,
        thisCallback: appCallback,
        callbackProps: { ACTION: VideoAction.closeVideo },
        closeButtonEl: document.getElementById("videoCloseButton")!,
      });

      document.getElementById(
        "videoModal"
      )!.className = `videoholder videoholder--show`;
      break;
    }
  }
};
/* --------   END OF CALLBACKS ------------------- */

/* RENDER SCREENS */

const hideScreen = (id: string) => {
  document.getElementById(id)!.style.display = "none";
};

const showScreen = (id: string) =>
  (document.getElementById(id)!.style.display = "block");

const updateCurrentPage = (newPage: screen) => {
  const previousPage: screen | null = mainState.currentScreen;
  if (previousPage) hideScreen(previousPage);
  mainState.currentScreen = newPage;
  showScreen(newPage);
};

/* ROUTES */
// ENTRY, INTRO VIDEO, INTRO ANIMATION, MAIN SCREEN
const initApp = () => {
  // hide all screens
  introScreens.forEach((screenId) => hideScreen(screenId));
  selectableScreens.forEach((screen) => hideScreen(screen.screenId));
  enterScreen();
};

const enterScreen = (): void => {
  const enterButton = document.getElementById("enterButton");
  enterButton!.addEventListener("click", (event) => {
    event.preventDefault();
    introVideoScreen();
  });
  updateCurrentPage(screen.Entry);
};

const introVideoScreen = () => {
  videoPlayerInstance = new MerapiVideoPlayer({
    playerName: "introPlayer",
    thisVideoId: "pitF4K1-VoQ",
    thisCallback: appCallback,
    callbackProps: { ACTION: VideoAction.skipIntroVideo },
    closeButtonEl: document.getElementById("skipIntroVideoButton")!,
  });

  updateCurrentPage(screen.IntroVideo);
};

const introAnimScreen = () => {
  initIntroAnimation(appCallback);
  const skipIntroButton = document.getElementById("skipIntroButton");
  if (skipIntroButton !== null) {
    skipIntroButton.addEventListener("click", (event) => {
      event.preventDefault();
      introAnimationQuit();
    });
  }
  updateCurrentPage(screen.Intro);
};

// main content screen also contains
// 1) themes filter to reduce number of displayed videos
// 2) modal vide player
// 3) nav menu to navigate to other screens
const gotoMainContentScreen = () => {
  initMainContent(peopleObj, dotsData, appCallback);
  themesInit(filterMenuItems, appCallback);
  navMenuInit(selectableScreens, appCallback);
  naviagteToNewScreen(screen.MainContent);
};

// after the intro screens and initial entry to the Main Screen
// new page selected from navigation menu
const naviagteToNewScreen = (newPage: screen) => {
  if (newPage === screen.MainContent) {
    setThemeNavMenuCTA("primary");
  } else {
    setThemeNavMenuCTA("dark");
  }
  updateCurrentPage(newPage);
};

export { initApp, appCallback };
